<router-outlet></router-outlet>

<footer class="tw-text-center tw-my-12">
  <environment-selector></environment-selector>

  <div bitTypography="body2">{{ "bitWebVault" | i18n }}</div>
  <br />
  <div bitTypography="helper" id="vw-disclaimer">
    {{ "vaultwardenDescription" | i18n }}
  </div>
</footer>
